<template>
  <div class="navigation">
    <div class="navMain myMain">
      <div class="logo" @click="toHome">
        <img src="@/assets/PC/navigation/navigation-logo.png" alt="">
      </div>
      <el-tabs v-model="pageName" @tab-click="changeTab">
        <el-tab-pane name="home">
          <template slot="label">{{$t('publicNavigation.navList.item1')}}</template>
        </el-tab-pane>
        <el-tab-pane name="product">
          <template slot="label">
            <div class="product" ref="productIcon">
              <span>{{$t('publicNavigation.navList.item2')}}</span>
              <img v-if="isProduct" src="@/assets/PC/navigation/Product-up.png" alt="">
              <img v-if="pageName !== 'product' && !isProduct" src="@/assets/PC/navigation/Product-down.png" alt="">
              <img v-if="pageName === 'product' && !isProduct" src="@/assets/PC/navigation/Product-down-active.png" alt="">
            </div>
          </template>
        </el-tab-pane>
        <el-tab-pane name="solution">
          <template slot="label">{{$t('publicNavigation.navList.item3')}}</template>
        </el-tab-pane>
        <el-tab-pane name="company">
          <template slot="label">{{$t('publicNavigation.navList.item4')}}</template>
        </el-tab-pane>
      </el-tabs>
      <div class="operate">
        <div class="book" @click="submitShow = true">{{$t('tryForFree')}}</div>
        <div ref="langIcon" class="langIcon" @click="isLang = !isLang">
          <img src="@/assets/PC/navigation/langIcon.png" alt="">
        </div>
      </div>
      <div class="langMenu" ref="langMenuPop" v-if="isLang">
        <div
          class="langMenuItem"
          :class="{activeLang: item.label === language}"
          v-for="(item, index) in langMenuList"
          :key="index"
          @click="changeLang(item.label)">
          {{item.value}}
        </div>
      </div>
    </div>
    <div class="productMenu" ref="productMenuPop" v-if="isProduct">
      <div class="myMain">
        <div
          class="menuItem"
          @click="jumpTo(item.router)"
          v-for="(item, index) in menuList"
          :key="index">
          <img :src="item.src" alt="">
          <div class="title">{{$t(`publicNavigation.menuList.${item.title}`)}}</div>
          <div class="subTitle">{{$t(`publicNavigation.menuList.${item.subTitle}`)}}</div>
        </div>
      </div>
    </div>
    <publicConsultation v-if="submitShow" @close="submitShow =false"></publicConsultation>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pageName: localStorage.getItem('pageName') || 'home',
      isProduct: false,
      menuList: [
        {
          src: require('@/assets/PC/navigation/EKYC.png'),
          title: 'item1Title',
          subTitle: 'item1Subtitle',
          router: 'ekyc'
        },
        {
          src: require('@/assets/PC/navigation/CreditScore.png'),
          title: 'item2Title',
          subTitle: 'item2Subtitle',
          router: 'creditScore'
        },
        {
          src: require('@/assets/PC/navigation/Anti-fraud.png'),
          title: 'item3Title',
          subTitle: 'item3Subtitle',
          router: 'antiFraud'
        },
        {
          src: require('@/assets/PC/navigation/Luna AI.png'),
          title: 'item4Title',
          subTitle: 'item4Subtitle',
          router: 'lunaAi'
        },
        {
          src: require('@/assets/PC/navigation/Intelligent-Overseas-Market.png'),
          title: 'item5Title',
          subTitle: 'item5Subtitle',
          router: 'aiAds'
        }
      ],
      langMenuList: [
        {
          label: 'zh',
          value: '中文'
        },
        {
          label: 'en',
          value: 'English'
        },
        {
          label: 'es',
          value: 'Español'
        },
        {
          label: 'id',
          value: 'Bahasa Indonesia'
        }
      ],
      language: '',
      isLang: false,
      submitShow: false
    }
  },
  mounted () {
    this.changeMenuList()
    document.addEventListener('click', this.handlerMonitor)
    this.language = localStorage.getItem('language') || this.$i18n.locale
    const productNameList = ['ekyc', 'creditScore', 'antiFraud', 'lunaAi', 'aiAds']
    if (productNameList.includes(this.$route.name)) {
      this.pageName = 'product'
    }
    if (['ekyc', 'lunaAi', 'aiAds'].includes(this.$route.name)) {
      this.langMenuList = [
        {
          label: 'zh',
          value: '中文'
        },
        {
          label: 'en',
          value: 'English'
        },
        {
          label: 'es',
          value: 'Español'
        }
      ]
    } else {
      this.langMenuList = [
        {
          label: 'zh',
          value: '中文'
        },
        {
          label: 'en',
          value: 'English'
        },
        {
          label: 'es',
          value: 'Español'
        },
        {
          label: 'id',
          value: 'Bahasa Indonesia'
        }
      ]
    }
  },
  watch: {
    isProduct: {
      handler (newValue) {
        if (!newValue) {
          if (this.pageName !== this.$route.name) {
            this.pageName = this.$route.name
          }
        }
      }
    }
  },
  methods: {
    toHome () {
      if (this.$route.name === 'home') {
        window.scrollTo(0, 0)
      } else {
        this.$router.push({ name: 'home' })
      }
    },
    changeTab (e) {
      if (e.name === 'product') {
        this.isProduct = !this.isProduct
        if (!this.isProduct) {
          localStorage.setItem('pageName', this.pageName)
        }
      } else {
        if (this.$route.name === e.name) {
          // window.scrollTo(0, 0)
          window.location.reload()
        } else {
          this.$router.push({ name: e.name })
        }
        localStorage.setItem('pageName', this.pageName)
      }
    },
    jumpTo (router) {
      if (this.$route.name === router) {
        window.scrollTo(0, 0)
        this.isProduct = !this.isProduct
      } else {
        this.$router.push({ name: router })
      }
    },
    changeLang (lang) {
      this.$i18n.locale = lang
      localStorage.setItem('language', lang)
      window.location.reload()
    },
    handlerMonitor (e) {
      this.monitorLanguage(e)
      this.monitorProduct(e)
    },
    // 语言切换弹窗的监听点击事件
    monitorLanguage (e) {
      const langMenuPop = this.$refs.langMenuPop
      const langIcon = this.$refs.langIcon
      if (langMenuPop) {
        if (!langMenuPop.contains(e.target) && langIcon.contains(e.target)) {
          this.isLang = true
        } else if (!langMenuPop.contains(e.target) && !langIcon.contains(e.target)) {
          this.isLang = false
        }
      }
    },
    // 产品菜单弹窗的监听点击事件
    monitorProduct (e) {
      const productMenuPop = this.$refs.productMenuPop
      const productIcon = this.$refs.productIcon
      if (productMenuPop) {
        if (!productMenuPop.contains(e.target) && productIcon.contains(e.target)) {
          this.isProduct = true
        } else if (!productMenuPop.contains(e.target) && !productIcon.contains(e.target)) {
          this.isProduct = false
        }
      }
    },
    changeMenuList () {
      if (this.$i18n.locale === 'id') {
        this.menuList = [
          {
            src: require('@/assets/PC/navigation/CreditScore.png'),
            title: 'item2Title',
            subTitle: 'item2Subtitle',
            router: 'creditScore'
          },
          {
            src: require('@/assets/PC/navigation/Anti-fraud.png'),
            title: 'item3Title',
            subTitle: 'item3Subtitle',
            router: 'antiFraud'
          }
        ]
      } else {
        this.menuList = [
          {
            src: require('@/assets/PC/navigation/EKYC.png'),
            title: 'item1Title',
            subTitle: 'item1Subtitle',
            router: 'ekyc'
          },
          {
            src: require('@/assets/PC/navigation/CreditScore.png'),
            title: 'item2Title',
            subTitle: 'item2Subtitle',
            router: 'creditScore'
          },
          {
            src: require('@/assets/PC/navigation/Anti-fraud.png'),
            title: 'item3Title',
            subTitle: 'item3Subtitle',
            router: 'antiFraud'
          },
          {
            src: require('@/assets/PC/navigation/Luna AI.png'),
            title: 'item4Title',
            subTitle: 'item4Subtitle',
            router: 'lunaAi'
          },
          {
            src: require('@/assets/PC/navigation/Intelligent-Overseas-Market.png'),
            title: 'item5Title',
            subTitle: 'item5Subtitle',
            router: 'aiAds'
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="less">
.navigation {
  width: 100%;
  background-color: #f6f8f7;
  position: fixed;
  top: 0;
  z-index: 9999;
}
.navMain {
  height: 1.44rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: visible;
}
.logo {
  width: 4.5rem;
  height: 100%;
  display: flex;
  align-items: center;
  img {
    width: 100%;
  }
}
.product {
  display: flex;
  align-items: center;
  span {
    font-size: 0.36rem;
  }
  img {
    width: 0.32rem;
    margin-left: 0.08rem;
  }
}
.operate {
  display: flex;
  align-items: center;
  .book {
    background-color: #07816A;
    padding: 0.16rem 0.4rem;
    border-radius: 0.4rem;
    color: #fff;
    margin-right: 0.2rem;
    cursor: pointer;
    font-weight: bold;
  }
}
// 语言切换
.langIcon {
  width: 0.96rem;
  height: 0.96rem;
  padding: 0.24rem;
  background-color: rgba(7, 129, 106, 0.1);
  border-radius: 0.96rem;
  cursor: pointer;
  img {
    width: 100%;
  }
}
.el-dropdown-link {
  color: #242B2A;
  font-size: 0.36rem;
}
.el-icon-arrow-down {
  color: #242B2A;
  font-size: 0.32rem;
}
/deep/ .el-tabs__item {
  color: #242B2A;
  font-size: 0.36rem;
}
// 整体的白线
/deep/ .el-tabs__nav-wrap::after {
  content: none;
}
// 选中的字体颜色
/deep/ .el-tabs__item.is-active {
  color: #07816A !important;
}
// 选中的底部线条
/deep/ .el-tabs__active-bar {
  background-color: rgba(0, 0, 0, 0);
  height: 0.08rem !important;
}
// 组件productMenu
.productMenu {
  position: absolute;
  bottom: 0;
  transform: translateY(100%);
  left: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.98);
  .myMain {
    display: flex;
    flex-wrap: wrap;
    padding: 0.6rem 0;
    .menuItem {
      width: 8rem;
      margin-right: 0.4rem;
      margin-bottom: 0.6rem;
      text-align: left;
      padding: 0.4rem;
      border-radius: 0.2rem;
      cursor: pointer;
      &:nth-child(3n) {
        margin-right: 0;
      }
      &:nth-child(4),
      &:nth-child(5) {
        margin-bottom: 0;
      }
      &:hover {
        background-color: #F7F9F8;
      }
      img {
        width: 0.64rem;
        height: 0.64rem;
      }
      .title {
        color: #242B2A;
        font-size: 0.4rem;
        font-weight: bold;
        margin: 0.2rem 0;
      }
      .subTitle {
        color: #242B2A;
        font-size: 0.32rem;
      }
    }
  }
}
// 组件langMenu
.langMenu {
  position: absolute;
  right: 0;
  bottom: 0;
  transform: translateY(100%);
  padding: 0.2rem;
  background-color: #fff;
  border-radius: 0.2rem;
  width: 4rem;
  .langMenuItem {
    text-align: left;
    padding: 0.2rem;
    color: rgba(36, 43, 42, 0.6);
    font-size: 0.28rem;
    font-weight: 700;
    cursor: pointer;
    &:hover {
      color: #07816A;
    }
  }
  .activeLang {
    color: #07816A !important;
  }
}
</style>
